export function buildLeaveConfirmMessage({
  isConcept = false,
  leavePreview = null,
  leavePreviewLoading = false,
  t,
}) {
  if (typeof t !== "function") return "";

  if (isConcept) {
    return t("events.details.leave_modal_concept.message");
  }

  if (leavePreviewLoading) {
    return t("events.details.leave_modal.loading");
  }

  if (!leavePreview) {
    return t("events.details.leave_modal.message");
  }

  if (!leavePreview.penalty_applies) {
    const lines = [
      leavePreview.recent_schedule_change
        ? t("events.details.leave_modal.friendly_no_penalty_recent_schedule_change")
        : leavePreview.pending_request_kind
          ? t("events.details.leave_modal.friendly_no_penalty_pending_request")
          : leavePreview.joined_grace
            ? t("events.details.leave_modal.friendly_no_penalty_join_grace")
            : t("events.details.leave_modal.friendly_no_penalty"),
    ];
    appendRatingAndSlotsSummary(lines, leavePreview, t);
    return lines.join("\n\n");
  }

  const penaltyType = String(leavePreview.penalty_type || "").trim().toLowerCase();
  const confirmedRequest = Boolean(leavePreview.confirmed_request);
  const isUnder6Hours =
    penaltyType === "leave_under_6h" ||
    penaltyType === "confirmed_leave_under_6h" ||
    Boolean(leavePreview.within_6_hours);

  const oldPenaltyPoints = {
    leave_under_24h: 10,
    leave_under_6h: 20,
    confirmed_leave: 10,
    confirmed_leave_over_12h: 10,
    confirmed_leave_under_12h: 15,
    confirmed_leave_under_6h: 20,
  };
  const penaltyPoints = leavePreview.penalty_points == null
    ? (oldPenaltyPoints[penaltyType] ?? 0)
    : Math.max(0, Number(leavePreview.penalty_points) || 0);
  const messageKey = (confirmedRequest || penaltyType.startsWith("confirmed_leave"))
    ? "events.details.leave_modal.friendly_penalty_confirmed_leave"
    : isUnder6Hours
      ? "events.details.leave_modal.friendly_penalty_under_6h"
      : "events.details.leave_modal.friendly_penalty_under_24h";
  const baseMessage = t(messageKey, { amount: penaltyPoints });

  const parts = [baseMessage];
  appendRatingAndSlotsSummary(parts, leavePreview, t);

  return parts.join("\n\n");
}

function appendRatingAndSlotsSummary(lines, leavePreview, t) {
  const scoreBefore = normalizeNumber(leavePreview?.participant_rating_score_before);
  const scoreAfter = normalizeNumber(leavePreview?.participant_rating_score_after);
  const activeJoinsAfter = normalizeNumber(leavePreview?.active_joins_after);

  if (scoreBefore != null && scoreAfter != null) {
    if (scoreBefore === scoreAfter) {
      lines.push(
        t("events.details.leave_modal.rating_stays", {
          score: scoreBefore,
        })
      );
    } else {
      lines.push(
        t("events.details.leave_modal.rating_change", {
          before: scoreBefore,
          after: scoreAfter,
        })
      );
    }
  }

  if (
    scoreBefore != null &&
    scoreBefore > 0 &&
    scoreAfter != null &&
    scoreAfter <= 0 &&
    activeJoinsAfter === 0
  ) {
    lines.push(t("events.details.leave_modal.slots_blocked_after"));
  }
}

function normalizeNumber(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  return Math.max(0, Math.round(number));
}
